import React from 'react';
import PropTypes from 'prop-types';
import { VCARD_BUTTON_MAIN_CLASSNAME, VCARD_BUTTON_LABEL_MAIN_CLASSNAME, VCARD_BUTTON_ICON_MAIN_CLASSNAME, VCARD_BUTTON_ICON_WATCH_WITH_MAIN_CLASSNAME } from '../Constants';
import { Button } from '../../../packages/components/lib/Button';
import { cls } from '../../../packages/components';
import Translator from '../../../requests/apa/Translator';
import {applyOutLineFocus} from "../../Focus/utils";
import DeviceStorage from "../../DeviceStorage/DeviceStorage";

const WatchWith = ({ text, family = '' }) => {
    return (
        <div className={VCARD_BUTTON_ICON_WATCH_WITH_MAIN_CLASSNAME}>
            <span className="bold">
                {text}
            </span>
            <span>
                { Translator.get(`${family}_access_description_button_subscriptionDescription`, '¿Qué incluye este canal?') }
            </span>
        </div>
    )
}

const VCardButton = ({ id = '', text, style = {},  family, icon, className, iconClassName, onClick = ()=>{}, elementopredeterminado = false, type='', taxes = '', isPromoCode = false}) => {
    let newText;
    const classNamePromoCode = isPromoCode ? `${VCARD_BUTTON_ICON_MAIN_CLASSNAME}-promo-code-title` : '';
    const classNameNoTaxes = taxes === '' ? `${VCARD_BUTTON_MAIN_CLASSNAME}-no-taxes` : '';

    //No se debe mostrar el botón de código promocional en peru
    const region = DeviceStorage.getItem("region");
    if(region === "peru" && isPromoCode) return null;

    const getIcon = () => {
        if(type === 'watch-with'){
            return <WatchWith text={text} family={family}/>
        }
        if(type === 'image'){
            newText = text;
            //Es una url
            return (
                <div className={`${VCARD_BUTTON_ICON_MAIN_CLASSNAME}-wrapper`}>
                    <img src={icon} alt="btn"/>
                </div>
            )
        }
        if(icon.indexOf('fa-')!==-1){
            newText = text;
            //Es una url
            return (
                <div className={`${VCARD_BUTTON_ICON_MAIN_CLASSNAME}-wrapper`}>
                    <i className={`fa ${icon}`}/>
                </div>
            )
        }
        if(type === 'text'){
            newText = text;
            // Es texto
            return <div className={cls(`${VCARD_BUTTON_ICON_MAIN_CLASSNAME}-wrapper`, classNameNoTaxes)}>
                    <div>
                        <span className={classNamePromoCode}>{icon}</span><span className={`${VCARD_BUTTON_ICON_MAIN_CLASSNAME}-taxes`}>{taxes}</span>
                    </div>
                </div>;
        }
    }

    const classOutLineFocus = applyOutLineFocus()

    return (
        <div className={cls(VCARD_BUTTON_MAIN_CLASSNAME, className)}>
            <Button
              id={type === 'watch-with' ? `${id}_yellowvcardaction`: id}
              dataOptions={{'data-sn-down':'.link-classic'}}
              style={style}
              onClick={onClick}
              className={cls(VCARD_BUTTON_ICON_MAIN_CLASSNAME, 'focusable', iconClassName, elementopredeterminado? 'elementopredeterminado':'', classOutLineFocus)}>
                {getIcon()}
            </Button>
            {
                newText && <span className={cls(VCARD_BUTTON_LABEL_MAIN_CLASSNAME)}>
                    {newText}
                </span>
            }
        </div>
    )
}

VCardButton.propTypes = {
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    onClick: PropTypes.func,
    elementopredeterminado: PropTypes.bool
}

VCardButton.defaultProps ={
    text: '',
    icon: '',
    className:'',
    iconClassName: '',
    onClick: ()=>{},
    elementopredeterminado: false,
}

export default VCardButton;



// WEBPACK FOOTER //
// ./src/components/Ficha/components/VCardButton.jsx